import * as React from "react";
import { OptionForm } from "../../../components/OptionForm";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import IssuerHeader from "../../../components/IssuerHeader";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
import dayjs from "dayjs";
export default function BaseHaveLoginRoute(_a) {
    var issuer = _a.issuer, options = _a.options;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(IssuerHeader, { issuer: issuer }),
            React.createElement(OptionForm, { submitId: "create-login", prompt: "Have you ever created an online login with ".concat(issuer === null || issuer === void 0 ? void 0 : issuer.name, "?"), options: options, footer: React.createElement("div", null,
                    "\u00A9 ",
                    dayjs().format("YYYY"),
                    " Trellis Technologies, Inc.",
                    React.createElement("br", null),
                    "Trellis is your secure, digital solution for obtaining your insurance information from your insurance company. Trellis is not affiliated or authorized by your insurance company.") }))));
}
